import React, { useEffect, useState } from 'react';

import {
  Button,
  Dropdown,
  Modal,
  TextField,
  WrapperFlex,
} from '@unimed-fesp/components';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { TipoEventoWebhookEnum } from '../../../enums';
import { Creators as WebhookEventIntegrationActions } from '../../../store/ducks/webhookEventIntegration';
import { ErrorToast } from '../../molecules/Toast';

function ModalCadastarWebhookEvent({
  isOpen,
  onClick,
  isEditar,
  setIsEditarModal,
}) {
  const dispatch = useDispatch();
  const { getWebhookListEvents, getWebhookConfiguration } = useSelector(
    (state) => state.webhookIntegration
  );

  const eventsCode = getWebhookListEvents.data;

  const [selectEventCode, setSelectEventCode] = useState(1);
  const [url, setUrl] = useState();

  const handleInputUrl = (event) => {
    setUrl(event.target.value);
  };

  const optionsEventCode = eventsCode.map((eventCode) => {
    return {
      onClickOption: () => {
        setSelectEventCode(eventCode.value);
      },
      text: eventCode.description,
    };
  });

  const cadastrarEvento = () => {
    if (!url || !selectEventCode) {
      return toast.error(
        <ErrorToast size="30">Os campos são obrigatórios.</ErrorToast>
      );
    }

    const params = {
      url,
      webhookId: getWebhookConfiguration.data.id,
      eventCode: selectEventCode,
    };

    dispatch(
      WebhookEventIntegrationActions.postWebhookEventIntegrationRequest(params)
    );

    onClick();
    limparInputs();
  };

  const limparInputs = () => {
    setSelectEventCode(1);
    setUrl('');
    setIsEditarModal(false);
  };

  const editarEvento = () => {
    const params = {
      url,
      webhookId: getWebhookConfiguration.data.id,
      eventCode: selectEventCode,
      entityId: isEditar.id,
    };

    dispatch(
      WebhookEventIntegrationActions.putWebhookEventIntegrationRequest(params)
    );

    dispatch(
      WebhookEventIntegrationActions.getWebhookEventsListRequest(
        getWebhookConfiguration.data.id
      )
    );
    onClick();
    limparInputs();
  };

  useEffect(() => {
    if (isEditar) {
      setSelectEventCode(
        TipoEventoWebhookEnum.returnIdForName[isEditar.eventCode]
      );
      setUrl(isEditar.url);
    }
  }, [isEditar]);

  return (
    <Modal
      isOpen={isOpen}
      onClick={() => {
        onClick();
        limparInputs();
      }}
      height={345}
      width={600}
      header={isEditar ? 'Editar Evento' : 'Cadastro de Eventos'}
      footer={
        <ModalFooter
          isEditar={isEditar}
          onClick={() => {
            onClick();
            limparInputs();
          }}
          cadastrarEvento={cadastrarEvento}
          editarEvento={editarEvento}
        />
      }
    >
      <WrapperFlex column fullWidth alignCenter justifyCenter>
        <TextField
          width={480}
          labelText="Url"
          value={url}
          onChange={(e) => {
            handleInputUrl(e);
          }}
        />
        <Dropdown
          options={optionsEventCode}
          tipo="dropdown"
          labelText="Opções de Eventos"
          name="eventCode"
          marginTop={11}
          height={46}
          width={480}
          disable={getWebhookListEvents.loading}
        >
          {TipoEventoWebhookEnum.returnDescriptionPorId[selectEventCode] ||
            (isEditar &&
              TipoEventoWebhookEnum.returnDescricao[isEditar.eventCode])}
        </Dropdown>
      </WrapperFlex>
    </Modal>
  );
}

const ModalFooter = ({ isEditar, onClick, cadastrarEvento, editarEvento }) => {
  return (
    <>
      <Button
        tipo="secondary"
        onClick={onClick}
        marginRight={10}
        type={isEditar ? 'button' : 'submit'}
        width={120}
        alignCenter
        justifyCenter
      >
        Cancelar
      </Button>
      <Button
        tipo="primary"
        onClick={isEditar ? editarEvento : cadastrarEvento}
        marginLeft={10}
        type={isEditar ? 'button' : 'submit'}
        width={120}
        alignCenter
        justifyCenter
      >
        Salvar
      </Button>
    </>
  );
};

export default ModalCadastarWebhookEvent;
